import styled from 'styled-components'
import { DealFillIcon, SameDayDeliveryIcon } from '@shipt/design-system-icons'
import { Body } from '@shipt/design-system-typography'
import {
  type AttributeTreatment,
  type StoreAttributeData,
} from '@/features/cms/components/CMS/types'
import { Badge } from '@shipt/design-system-badge'

export const StoreAttribute = ({
  astro_icon,
  text,
  treatment,
  isDetailed,
}: {
  astro_icon?: StoreAttributeData['astro_icon']
  text: string
  treatment: AttributeTreatment
  isDetailed?: boolean
}) => {
  const icon = () => {
    switch (astro_icon) {
      case 'DealFillIcon':
        return DealFillIcon

      case 'SameDayDeliveryIcon':
        return SameDayDeliveryIcon

      default:
        return undefined
    }
  }
  switch (treatment) {
    case 'Primary Loud':
      return (
        <Badge icon={icon()} size="xs" variant="positive" concept="feedback">
          {text}
        </Badge>
      )
    case 'Secondary Loud':
      return (
        <TileCallout strong size={isDetailed ? { base: 'sm', md: 'md' } : 'sm'}>
          {text}
        </TileCallout>
      )
    case 'Subtle':
      return (
        <Body size="md" variant="secondary">
          {text}
        </Body>
      )
    default:
      return null
  }
}

const TileCallout = styled(Body)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
